import React from 'react';
import { Button, Card, StatusBadge, StatusBadgeTone } from '../common';

/* FeedSummaryCard — one row in the feeds list.
   Name + LED status badge + description + edition count, with optional
   open / delete actions. Mirrors the pattern used on UnifiedFeedsPage so
   the live page and the design-system showcase share one implementation. */

interface FeedSummaryCardProps {
  name: string;
  description?: string | null;
  badge?: {
    label: string;
    tone: StatusBadgeTone;
  };
  itemCount?: number;
  onOpen?: () => void;
  onDelete?: () => void;
}

export default function FeedSummaryCard({
  name,
  description,
  badge,
  itemCount,
  onOpen,
  onDelete,
}: FeedSummaryCardProps) {
  return (
    <Card>
      <div className="flex items-start justify-between gap-4">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-3 mb-1 flex-wrap">
            <h3 className="font-display text-lg font-bold lowercase tracking-[-0.02em] text-foreground truncate">
              {name}
            </h3>
            {badge && <StatusBadge tone={badge.tone}>{badge.label}</StatusBadge>}
          </div>
          {description && (
            <p className="font-body text-sm text-muted-foreground mb-2 line-clamp-2">
              {description}
            </p>
          )}
          {itemCount !== undefined && (
            <p className="font-mono text-xs tracking-[0.14em] uppercase text-muted-foreground">
              {itemCount} episode{itemCount === 1 ? '' : 's'}
            </p>
          )}
        </div>

        {(onOpen || onDelete) && (
          <div className="flex flex-col items-end gap-2 shrink-0">
            {onOpen && (
              <Button variant="primary" size="sm" onClick={onOpen}>
                open
              </Button>
            )}
            {onDelete && (
              <Button variant="danger" size="sm" onClick={onDelete}>
                delete
              </Button>
            )}
          </div>
        )}
      </div>
    </Card>
  );
}
